import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useHidePopUp from "../../hooks/useHidePopUp";

const SearchForm = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const userData = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();
  const suggestionsRef = useRef();
  const [pages, setPages] = useState([
    {
      element: "Dashboard",
      path: "/dashboard",
    },
    {
      element: "Projects",
      path: "/projects",
    },
    {
      element: "Domains",
      path: "/domains",
    },
    {
      element: "Tutorials",
      path: "/tutorials",
    },
    {
      element: "Resources",
      path: "/resources",
    },
    {
      element: "Settings",
      path: "/settings",
    },
    {
      element: "New Project",
      path: "/projects/select-project-type",
    },
    {
      element: "Change Password",
      path: "/settings",
    },
    {
      element: "New Tutorial",
      path: "/tutorials/create",
    },
    {
      element: "Agencies",
      path: "/agencies",
    },
    {
      element: "All Users",
      path: "/stripe/all-users",
    },
  ]);

  useEffect(() => {
    if (!["admin", "superadmin"].includes(userData?.role)) {
      setPages(
        pages.filter((p) => !["Agencies", "All Users"].includes(p.element)),
      );
    }
  }, [userData?.role]);

  useHidePopUp(suggestionsRef);

  useEffect(() => {
    if (searchQuery.trim()) {
      const filteredSuggestions = pages.filter((item) =>
        item.element.toLowerCase().includes(searchQuery.toLowerCase()),
      );
      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]);
    }
  }, [searchQuery]);

  // const handleSearch = (e) => {
  //   e.preventDefault();
  //   if (searchQuery.trim()) {
  //     // navigate(`/search?query=${encodeURIComponent(searchQuery)}`);
  //     navigate(searchQuery);
  //     setSuggestions([]);
  //   }
  // };

  const handleSuggestionClick = (suggestion) => {
    setSearchQuery(suggestion.path);
    // navigate(`/search?query=${encodeURIComponent(suggestion.path)}`);
    navigate(suggestion.path);
    setSearchQuery("");
    setSuggestions([]);
  };

  return (
    <>
      <form
        onSubmit={(e) => e.preventDefault()}
        // onSubmit={handleSearch}
        className="px-[23px] flex items-center relative border border-[#495E6B] rounded-[10px] gap-x-2.5"
      >
        <input
          type="text"
          name="search"
          className="flex-1 block appearance-none w-full bg-transparent py-3 font-medium text-[14px] leading-normal text-white outline-none placeholder:text-white/70"
          placeholder="What can we help you find?"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <button
          type="submit"
          className="flex items-center justify-center shrink-0 w-[24px] h-[24px] group"
        >
          <svg
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.744 13.0097L11.0343 10.2989C13.0618 7.58945 12.509 3.74936 9.79955 1.72186C7.0901 -0.305644 3.25002 0.24719 1.22252 2.95664C-0.804987 5.66609 -0.252153 9.50618 2.4573 11.5337C4.63375 13.1623 7.62307 13.1623 9.79955 11.5337L12.5104 14.2445C12.851 14.5852 13.4033 14.5852 13.744 14.2445C14.0846 13.9038 14.0846 13.3515 13.744 13.0109L13.744 13.0097ZM6.15102 11.0105C3.74298 11.0105 1.79091 9.05839 1.79091 6.65036C1.79091 4.24233 3.74298 2.29025 6.15102 2.29025C8.55905 2.29025 10.5111 4.24233 10.5111 6.65036C10.5086 9.0573 8.55799 11.0079 6.15102 11.0105Z"
              fill="#B8BEC1"
              className="transition-all group-hover:fill-white"
            />
          </svg>
        </button>
      </form>
      {suggestions.length > 0 && (
        <ul
          ref={suggestionsRef}
          className="absolute w-[790px] bg-black-100 border border-t-0 border-[#495E6B] rounded-md max-h-40 overflow-auto"
        >
          {suggestions.map((suggestion, index) => (
            <li
              key={index}
              className="px-4 py-2 text-white cursor-pointer hover:bg-[#495E6B]"
              onClick={() => handleSuggestionClick(suggestion)}
            >
              {suggestion.element}
            </li>
          ))}
        </ul>
      )}
    </>
  );
};
export default SearchForm;
